import React from 'react';
//import styles from './styles.module.scss';
// Используется для тестирования компонентов

const TestPage: React.FC = () => {
    return <></>
}
export { TestPage };
